import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { ConsumerPortalApiService } from './consumer-portal-api.service';

export const APP_CONFIG = new InjectionToken('Application config');

@Injectable({
    providedIn: 'root'
})
export class GoogleMapApiService {
    protected http = inject(HttpClient);
    private readonly notification = inject(NotificationService);
    private readonly consumerPortalApi = inject(ConsumerPortalApiService);

    getLatLong(
        addressLine: string,
        googleMapsGeocodeApiUrl: string | undefined, // will come as part of configuration for Consumer Portal
        googleMapsApiKey: string | undefined
    ) {
        if (googleMapsGeocodeApiUrl && googleMapsGeocodeApiUrl.length > 5) {
            return this.http.get(`${googleMapsGeocodeApiUrl}?key=${googleMapsApiKey}&address=${addressLine}`).pipe(map(res => res));
        } else {
            this.notification.error('invalid Google Maps API URL on GOOGLE MAP SERVICE');
            return false;
        }
    }
}
